import React, { SyntheticEvent, useEffect, useState } from 'react';
import { FormControl, FormHelperText, Slider } from '@mui/material';
import { Control, useController } from 'react-hook-form';
import { moneyFormatter } from '@utils/formatter';

interface RangeProps {
  name: string;
  testid?: string;
  disabled?: boolean;
  // eslint-disable-next-line
  control: Control<any>;
  min?: number;
  max?: number;
  step?: number;
  onChange: (name: string, value: number | number[]) => void;
  valueLabelDisplay: 'auto' | 'off' | 'on';
  valueLabelFormat?: string | ((value: number, index: number) => React.ReactNode);
  getAriaValueText?: (value: number) => string;
  showMaxValue?: boolean;
}

export const Range = (props: RangeProps) => {
  const {
    name,
    disabled,
    control,
    valueLabelDisplay,
    min = 0,
    max = 100,
    step,
    onChange,
    valueLabelFormat,
    getAriaValueText,
    testid,
  } = props;
  const {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    field: { value, onChange: onFieldChange, ...rest },
    fieldState,
  } = useController({
    name,
    control,
    defaultValue: 0,
  });
  const [range, setRange] = useState<number>(0);

  useEffect(() => {
    setRange(value as number);
  }, [value]);

  const handleChangeCommitted = (event: SyntheticEvent | Event, fieldValue: number | number[]) => {
    onChange(name, fieldValue);
  };

  const handleChange = (event: Event, fieldValue: number | number[]) => {
    setRange(fieldValue as number);
  };

  const marks = [
    { label: `${moneyFormatter.format(min)}`, value: min },
    { label: `${moneyFormatter.format(max)}`, value: max },
  ];

  return (
    <FormControl size="small" fullWidth sx={{ padding: '0 1.25rem' }}>
      <Slider
        {...rest}
        onChangeCommitted={handleChangeCommitted}
        onChange={handleChange}
        value={range}
        disabled={disabled}
        marks={marks}
        step={step}
        min={min}
        max={max}
        getAriaValueText={getAriaValueText}
        valueLabelDisplay={valueLabelDisplay}
        valueLabelFormat={valueLabelFormat}
        data-testid={testid}
      />

      {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
    </FormControl>
  );
};
